export default "__VITE_ASSET__1332bce6__"